module.exports = __webpack_public_path__ + "static/media/ipo3.c0d98436.png";